// src/features/coupon/utils/coupon.utils.ts

import type {
  UserCoupon,
} from '../types/coupon.types';


/**
 * 사용자가 직접 사용할 수 있는 쿠폰인지 확인
 *
 * USER 직접 사용 가능:
 *
 * FIXED
 * - POINT
 * - STORE_POINT
 *
 * RANDOM
 * - 사용 가능
 *
 * USER 직접 사용 불가:
 *
 * FIXED
 * - FREE_GAME
 * - SATELLITE
 * - SEAT
 * - ETC
 */
export const canUserUseCoupon = (
  coupon: UserCoupon,
): boolean => {

  /**
   * AVAILABLE 상태가 아니면
   * 사용할 수 없음
   */
  if (
    coupon.status !==
    'AVAILABLE'
  ) {
    return false;
  }


  /**
   * RANDOM 쿠폰은
   * USER 직접 사용 가능
   *
   * 백엔드 생성 단계에서
   * POINT / STORE_POINT만
   * rewardOption으로 허용
   */
  if (
    coupon.rewardMode ===
    'RANDOM'
  ) {
    return true;
  }


  /**
   * FIXED 쿠폰은
   * POINT / STORE_POINT만
   * USER 직접 사용 가능
   */
  return (
    coupon.rewardType ===
      'POINT' ||
    coupon.rewardType ===
      'STORE_POINT'
  );
};